import cx from 'classnames'
import { MdNotifications, MdNotificationsOff } from 'react-icons/md'

import { FriendlyDateTime } from '../../../shared/Date/friendly-date-time'
import { useParentMeasure } from '../../../shared/measure'

const Section4 = ({ lastUpdateDatetime, symptoms, symptomsGray, doAlert }) => {
  const parentMeasure = useParentMeasure()

  const doAlertRender = () => {
    if (doAlert === null) {
      return null
    }
    if (doAlert) {
      return (
        <div title='Alert was enabled'>
          <MdNotifications />
        </div>
      )
    }
    return (
      <div title='Alert was disabled'>
        <MdNotificationsOff />
      </div>
    )
  }
  const RenderLastUpdatedHeader = () =>
    (lastUpdateDatetime
      ? (
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '5px', marginBottom: '2px' }}>
          <span>
            Symptoms - {' '}
            <FriendlyDateTime
              datetime={lastUpdateDatetime}
              className='bold'
            />

          </span>
          {doAlertRender()}
        </div>
      )
      : (<span>No Symptoms Reported in 21 Days</span>))

  return (
    <div className='section-4'>
      <RenderLastUpdatedHeader />

      <div className={cx('symptoms', [ parentMeasure && parentMeasure.width < 1200 && 'small' ])}>
        {symptoms.map((symptom, i) => (
          <span
            key={symptom.name}
            className={cx(symptomsGray[i].color, {
              current: symptom.current
            })}
          >
            {symptom.name}
          </span>
        ))}
      </div>
    </div>
  )
}

export default Section4
